import { ameya } from "./ameya";
import { sirulaseema1 } from "./sirulaseema-1";
import { sirulaseema2 } from "./sirulaseema-2";
import { suketana } from "./suketana";
import { vibhava } from "./vibhava";

export const projects = [vibhava, ameya, suketana, sirulaseema2, sirulaseema1];

export function getProject(slug: string) {
  return projects.find((project) => project.slug === slug);
}
